import { FundingPolicyType } from '@shared/appModel';
import { isCareMattersFamily } from '@shared/FundingPolicyTypeDef';
import { cmTwoPresentation } from './cmTwoPresentation';
import { nylAssetFlexPresentation } from './nylAssetFlexPresentation';
import { defaultPresentation, StrategyPresentation } from './types';

export function getPresentation(
  policyType: FundingPolicyType | null | undefined,
): StrategyPresentation {
  if (!policyType) return defaultPresentation;
  if (isCareMattersFamily(policyType)) return cmTwoPresentation;
  if (policyType === FundingPolicyType.nylAssetFlex) return nylAssetFlexPresentation;
  return defaultPresentation;
}
